import $ from "jquery";
import CONSTANT from "../../common/js/_constant";

const csrPolicies = {
  variables: {
    pdfLink: ".pdf-link",
    csrPolicies: ".csr-policies",
  },
  methods: {
    openPdf: function () {
      $(csrPolicies.variables.pdfLink).on(
        CONSTANT.eventsListners.CLICK,
        function (event) {
          event.preventDefault();
          const url = $(this).attr("href");
          const targetBlank = $(this).data("targetblank");
          if (targetBlank) {
            window.open(url, "_blank");
          } else {
            window.location.href = url;
          }
        }
      );
    },

    init: function () {
      csrPolicies.methods.openPdf();
    },

    csrPoliciesClickHandler: function () {
                               $('.csr-policies__cards--link').on('click', function(e){
                               var obj = csrPolicies.methods.dataLayerObj(e);
                               let flag = document.querySelector("input[name='pageType']") != null && (document.querySelector("input[name='pageType']").value == 'Product' || document.querySelector("input[name='pageType']").value == 'Category Page') ? true : false;
                               if(flag){
                                 createDataLayer('Download_Product',obj);
                               }
                               else{
                               createDataLayer("Download_NonProduct", obj);
                            }
                           });
                         },
            dataLayerObj: function (e) {
                      var obj = {
                        'articleName': "",
                        'blogCategory': "",
                        'blogPageCategory': "",
                        'buttonText':  e.currentTarget.innerText.replace(/\n/g, '').trim(),
                        'pageSection': "CSR Policies",
                        'pageType': "CSR Policies",
                        'planOption': "",
                        'productCategory': "",
                        'productName': "",
                        'question': "",
                        'source': "",
                        'searchTerm': "",
                        'videoTitle': "",
                        'bannerName': "",
                      };
                      return obj;
                    },
  },
};
$(document).ready(function () {
csrPolicies.methods.csrPoliciesClickHandler();
});

$(() => {
  if ($(csrPolicies.variables.csrPolicies).length > 0) {
    csrPolicies.methods.init();
  }
});
